angular.module("rjmNg.common.directives").directive "googleAnalyticsMetricsAndDimensions", [
  "GoogleAnalyticsMetadata"
  "GoogleAnalyticsReportValidator"
  "app"
  "notification"
  (
    GoogleAnalyticsMetadata
    GoogleAnalyticsReportValidator
    app
    notification
  ) ->
    bindToController: true
    controllerAs: "view"
    require: "^?rjmUi"
    restrict: "E"
    scope:
      connection: "="
    templateUrl: "googleAnalyticsMetricsAndDimensions/directive.googleAnalyticsMetricsAndDimensions.html"
    controller: [
      () ->

        view = @

        view.loading = true
        view.state = null
        view.STATES = GoogleAnalyticsReportValidator.STATES

        view.metrics = []
        view.dimensions = []

        view.updateConnectionProperties = () ->
          view.connection.properties.metrics = JSON.stringify(view.connectionMetrics)
          view.connection.properties.dimensions = JSON.stringify(view.connectionDimensions)

        getTagsFromMetadata = (groupsForType) ->
          Object.keys(groupsForType).map (group) ->
            name: group
            options: groupsForType[group].map (metric) ->
              id: metric.id
              name: metric.id
          .sort (firstItem, secondItem) ->
            firstItem.name.localeCompare(secondItem.name)

        GoogleAnalyticsMetadata.queryWithGrouping(app.getGoogleAnalyticsReportingKey())
        .then (metadata) ->
          view.metrics = getTagsFromMetadata(metadata.metrics)
          view.dimensions = getTagsFromMetadata(metadata.dimensions)
        .catch () ->
          notification.error "Something went wrong.", "An error occurred while
            loading the permissible metrics and dimensions for this connection.
            Please try refreshing the page, and contact support if the problem
            persists.", "connector"
        .finally () ->
          view.loading = false

        @$onInit = ->
          view.isNewConnection = not Number(view.connection?.properties?.metrics_and_dimensions_set)

          if view.connection.properties?.metrics?
            view.connectionMetrics = JSON.parse(view.connection.properties.metrics)
          else
            view.connectionMetrics = []

          if view.connection.properties?.dimensions?
            view.connectionDimensions = JSON.parse(view.connection.properties.dimensions)
          else
            view.connectionDimensions = []

          view.updateConnectionProperties()

        view

    ]
    link: (scope, element, attributes, rjmUi) ->

      view = scope.view

      validationStream = new GoogleAnalyticsReportValidator.ValidationStream(
        app.getClientId()
        "dashapp"
        (state) ->
          view.state = state
      )

      connectionChanged = () ->
        if view.isNewConnection
          view.updateConnectionProperties()
          validationStream.validate(view.connection)

      scope.$watchCollection("view.connectionMetrics", connectionChanged)
      scope.$watchCollection("view.connectionDimensions", connectionChanged)

      if rjmUi?
        scope.$watch "view.loading", () ->
          rjmUi.loadingUi("google-analytics-metrics-and-dimensions", view.loading)

]
